// Timestamp — a point in time, branded epoch-milliseconds.
//
// Lives at the top of the surface (alongside `Actor`, `EntityRef`)
// because it is a cross-BC primitive: the first consumer is
// `Context.Ambient.recencyBoost` (`context/ambient.ts`), but "a
// moment in wall-clock time" is not owned by any one BC.
//
// **Distinct from `@bilda/app`'s `Timestamp`** (`packages/app/src/
// envelope.ts`, an ISO-8601 string brand for event-log recording).
// Core cannot import App's type — `core` sits below `app` in the
// package topology (see the repo's packages-at-a-glance) — so this is
// a second, core-owned brand with the same real-world meaning but a
// different representation (epoch milliseconds, not an ISO string) —
// milliseconds are what `recencyBoost`'s `exp(-Δt / halfLife)` needs
// to compute directly, with no parse step inside the pure core. The
// app-layer shell converts its own `Timestamp` (`ctx.now()`) into this
// brand at the workflow boundary (`Date.parse` is a pure string→number
// function, not I/O) — see `app/src/workflows/showAmbientContext.ts`.
export { mk };
// The sanctioned brand site. Trusts its input — callers derive a
// `Timestamp` from a wall-clock read (`Date.now()`) or a parsed ISO
// string (`Date.parse(...)`), never from an untrusted literal.
const mk = (epochMs) => epochMs;
//# sourceMappingURL=timestamp.js.map